import { getMqttSource } from '@/lib/mqtt/source';
import { useCallback, useEffect, useRef, useState } from 'react';
import type { PublishState } from '../types';

/** Flag-gated publish with a small state machine for button feedback. */
export function usePublishMessage() {
  const enabled = true;
  const [state, setState] = useState<PublishState>('idle');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetAfter = useCallback((ms: number) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setState('idle'), ms);
  }, []);

  const publish = useCallback(
    async (topic: string, payload: string, qos: 0 | 1 | 2) => {
      if (!enabled) return;
      setState('sending');
      try {
        await getMqttSource().publish(topic, payload, { qos });
        setState('sent');
        resetAfter(1200);
      } catch {
        setState('error');
        resetAfter(2000);
      }
    },
    [enabled, resetAfter],
  );

  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );

  return { enabled, state, publish };
}
